import { http } from '@/utils/http';
import qs from 'qs';

const BASEURL = '/vote/2020project/2020calligraphy/controller.php?enews=';

export const getBaseInfo = () => {
  return http.get(`${BASEURL}base-info`);
};

export const getRules = () => {
  return http.get(`${BASEURL}rules`);
};

export const getType = () => {
  return http.get(`${BASEURL}getType`);
};
export const getWorkType = () => {
  return http.get(`${BASEURL}getWorkType`);
};
export const getAreas = () => {
  return http.get(`${BASEURL}getAreas`);
};
// 用户个人列表
interface IuserList {
  unionid: any;
}
export const userList = (page: number, data: IuserList) => {
  return http.post(`${BASEURL}vote-list-user&page=` + page, qs.stringify(data));
};

// 个人列表删除接口
interface IDelList {
  id: number;
  unionid: any;
}
export const userDel = (data: IDelList) => {
  return http.post(`${BASEURL}delete`, qs.stringify(data));
};

// 详情
export const detail = (id: any) => {
  return http.get(`${BASEURL}detail`, {
    params: { id },
  });
};

interface ISchoolsOption {
  search?: string | number;
}
// 学校搜索
export function getSchools({ search }: ISchoolsOption) {
  return http.get(`${BASEURL}getSchools`, {
    params: { search },
  });
}

interface IVoteListOption {
  page?: number;
  type?: any;
  search?: string | number;
  workType?: any;
  county?: any;
}
// 投票列表页
export function getVoteList({
  page,
  type,
  search,
  workType,
  county,
}: IVoteListOption) {
  return http.get(`${BASEURL}vote-list`, {
    params: { page, type, search, workType, county },
  });
}

// 报名页面提交报名接口
export function save(data: any) {
  const qsData = qs.stringify(data);
  return http.post(`${BASEURL}save`, qsData);
}
